import $ from "jquery";
import LazyLoad from "vanilla-lazyload";

$(function () {
  // Setup image lazy loader
  new LazyLoad();
});
